import { gql } from '@apollo/client';

export const ADD_UPDATE_APPROVAL_TYPE = gql`
  mutation addOrUpdateApprovalType($input: ApprovalTypeItemInput) {
    addOrUpdateApprovalType(input: $input) {
      commandId
    }
  }
`;

export const DELETE_APPROVAL_TYPE_LEVEL = gql`
  mutation deleteApprovalTypeLevel($input: DeleteApprovalTypeLevelInput) {
    deleteApprovalTypeLevel(input: $input) {
      commandId
    }
  }
`;
